import React from "react";
import Constants from "../../Constants";
import { withRouter } from "react-router-dom";
const TagItem = ({ tag, history, setShowSearch }) => {
  const slug = tag.tag_name.toLowerCase().replace(/ /g, "-");
  return (
    <div
      className="row"
      onClick={() => {
        setShowSearch(false);
        history.push(`${Constants.HOME}tag/${slug}/${tag.id}`);
      }}
    >
      <div className="item_tag">
        <i className="icon-tag"></i>
        <span>{tag.tag_name.toLowerCase()}</span>
        <i className="icon-arrow-right"></i>
      </div>
    </div>
  );
};

export default withRouter(TagItem);
